export default __webpack_public_path__ + "static/media/photo3.af7420c3.png";